import iconCheckGreen from '../../../assets/images/icon-check-green.png';
import iconError from '../../../assets/images/icon-error.png';
import {checkboxIconStyle} from '../../UI/checkboxIconStyle';

export const useStyles = () => ({
	fsMd: {
		fontSize: 16,
	},
	paymentInfoLine: {
		marginBottom: 10,
		justifyContent: 'space-between',
	},
	paymentInfoContainer: {
		margin: '0 auto',
		background: 'transparent',
		maxWidth: 320,
		fontFamily: 'Spartan, sans-serif',
		'& $paymentInfoLine:nth-child(3)': {
			marginBottom: 15,
		}
	},
	paymentNotEligible: {
		color: '#283339',
		fontSize: 14,
		fontWeight: 600,
		'& a': {
			color: '#5058C8',
			textDecoration: 'underline',
			cursor: 'pointer',
		},
		'& span': {
			color: '#E52866',
		}
	},
	paymentInfoLabel: {
		fontSize: 14,
		lineHeight: '20px',
		color: '#283339',
		fontWeight: 700,
	},
	paymentInfoValueGrey: {},
	paymentInfoValue: {
		fontSize: 14,
		lineHeight: '18px',
		color: '#283339',
		fontWeight: 700,
		textAlign: 'right',
	},
	couponContainer: {
		alignItems: 'flex-start',
	},
	couponInitBtn: {
		color: '#A6A9AB',
		fontSize: 12,
		fontWeight: 600,
		cursor: 'pointer',
	},
	couponBtn: {
		color: '#fff',
		backgroundColor: '#ff8f00',
		border: 'none',
		padding: 5,
		fontSize: 12,
		fontWeight: 700,
		borderRadius: 6,
		textTransform: 'initial',
		lineHeight: '13px',
		maxHeight: '28px',
		boxShadow: 'none',
		marginTop: 1,
		marginLeft: 7,
		'&:hover': {
			backgroundColor: '#ff8f00',
			border: 'none',
		},
	},
	couponSection: {
		maxWidth: 350,
		'& .MuiOutlinedInput-root input.MuiOutlinedInput-input': {
			fontSize: 12,
			padding: 6
		}
	},
	couponSectionMessagesBox: {
		paddingTop: '0px !important',
		paddingBottom: '0px !important',
	},
	couponCodeMessage: {
		fontSize: 11,
		fontWeight: 600,
	},
	couponCodeSuccess: {
		position: 'relative',
		color: '#28D799',
		paddingLeft: 20,
		marginTop: 3,
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: 0,
			left: 0,
			width: 16,
			height: 14,
			backgroundImage: `url(${iconCheckGreen})`,
			backgroundSize: '100%',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
		},
	},
	couponCodeError: {
		position: 'relative',
		color: '#E52866',
		paddingLeft: 20,
		marginTop: 3,
		'&:before': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			display: 'block',
			width: 15,
			height: 14,
			backgroundImage: `url(${iconError})`,
			backgroundSize: '100%',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
		}
	},

	paymentTotal: {
		color: '#283339',
		fontSize: 20,
		fontWeight: 700,
		lineHeight: '30px',
		marginTop: 5,
	},
	paymentInfoBilling:  {
		color: '#6D7173',
		fontSize: 11,
		fontWeight: 600,
		lineHeight: '16px',
	},
	lineThrough: {
		textDecoration: 'line-through',
	},
	textGreen: {
		color: '#1C9A6E',
	},
	textGrey: {
		color: '#333333',
	},
	textBlue: {
		color: '#0254ad',
	},
	savingPercentBg: {

	},
	paymentInfoSavingContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginBottom: 10,
	},
	paymentInfoSaving: {
		fontWeight: 700,
		color: '#1C1E22',
		background: '#84E8C5',
		maxWidth: 200,
		padding: '6px 15px 5px',
		borderRadius: 30,
		display: 'inline-block',
		textAlign: 'center',
	},
	paymentInfoCCContainerV2: {
		'&$paymentInfoContainer': {
			maxWidth: '100%',
		},
		'& $lineThrough': {
			color: '#6d7173',
		},
	},
	paymentInfoPayPalContainerV2: {
		'&$paymentInfoContainer': {
			maxWidth: '100%',
			padding: '20px 0px 10px',
			borderRadius: 30,
			background: '#ffffff',
			margin: '0 auto',
		},
		'& $lineThrough': {
			color: '#6d7173',
		},
	},
	planRenew: {
		fontSize: 11,
		fontWeight: 600,
		color: '#6D7173',
		marginBottom: 10,
		textAlign: 'right',
	},
	errorIcon: {
		position: 'relative',
		top: 0,
		paddingLeft: 20,
		fontSize: 11,
		fontWeight: 600,
		color: '#E52866',
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: '-2px',
			left: 3,
			width: 15,
			height: 13,
			backgroundImage: `url(${iconError})`,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
		},
	},
	checkbox: {
		marginTop: '-9px',
	},
	checkboxError: {
		color: '#f44336',
		'& $checkboxIcon': {
			borderColor: '#f44336',
		},
	},
	errorText: {
		width: 'auto',
		color: '#f44336',
		fontSize: '0.75rem',
		lineHeight: 1,
		padding: '4px 0 0 24px',
	},
	termsCheckbox: {
		alignItems: 'flex-start',
		'& .Mui-checked': {
			color: '#1c1e22',
		},
	},
	...checkboxIconStyle(),
	terms: {
		fontSize: 12,
		lineHeight: '22px',
		display: 'inline-block',
		color: '#283339',
		fontWeight: 600,
		fontFamily: 'Spartan, sans-serif',
		'& a': {
			color: '#283339'
		}
	},
	paymentInfoSentry: {
		display: 'flex',
		alignItems: 'center',
		fontSize: 14,
		lineHeight: '20px',
		fontWeight: 700,
		background: '#F9F9F9',
		borderRadius: 12,
		padding: '14px 16px',
		marginLeft: '-16px',
		marginRight: '-16px',
	},
	paymentInfoAddSentry: {
		padding: '8px 20px 5px',
		cursor: 'pointer',
		border: 'solid 2px #FF8F00',
		color: '#FF8F00',
		borderRadius: '10px',
		fontSize: 15,
		display: 'inline-block',
		transition: 'all 0.2s ease-in-out',
		'&:hover': {
			color: '#fff',
			border: 'solid 2px #FF8F00',
			backgroundColor: '#FF8F00',
		},
	},
	paymentInfoSeparator: {
		height: 1,
		background: '#E9EAEB',
		margin: '24px 0 20px 0',
	},
	'@media (max-width: 500px)': {
		couponContainer: {
			alignItems: 'flex-start',
			flexDirection: 'column',
		},
		paymentInfoSaving: {
			alignSelf: 'flex-end',
			marginTop: 5,
		},
	},
	'@media (max-width: 460px)': {
		couponSection: {
			width: '100%',
			maxWidth: '100%',
			marginBottom: 10,
		},
		paymentTotal: {
			fontSize: 18,
		},paymentInfoCCContainerV2: {
			'& $paymentTotal': {
				fontSize: 16,
			},
		},
		paymentInfoPayPalContainerV2: {
			'& $paymentTotal': {
				fontSize: 16,
			},
		},
	},
});